/*!
 * fine-mq v1.0.3
 * (c) 2018-present Honoré Nintunze <nintu.lab@gmail.com>
 * Released under the MIT License.
 */
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

var Mq =
/*#__PURE__*/
function () {
  function Mq() {
    var aliases = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Mq);

    this.aliases = aliases;
    this.queries = {};
  }

  _createClass(Mq, [{
    key: "alias",
    value: function alias(_alias, query) {
      if (query) {
        this.aliases[_alias] = query;
        return this;
      }

      this.aliases = Object.assign({}, this.aliases, _alias);
      return this;
    }
  }, {
    key: "unalias",
    value: function unalias(alias) {
      var queryObject = this.queries[this.aliases[alias]];
      if (queryObject) this.off(alias);
      delete this.aliases[alias];
      return this;
    }
  }, {
    key: "on",
    value: function on(query, callback, context) {
      context = context || this;
      var res = this.queries[this.aliases[query] || query];
      var queryObject = res ? res : {
        handlers: [],
        mqMatcher: window.matchMedia(this.aliases[query] || query)
      };

      queryObject.listener = function () {
        queryObject.handlers.forEach(function (handler) {
          return handler.callback.call(handler.context, {
            matcher: queryObject.mqMatcher,
            alias: query
          });
        });
      };

      queryObject.mqMatcher.addListener(queryObject.listener);
      var handler = {
        callback: callback,
        context: context
      };
      queryObject.handlers.push(handler);
      this.queries[this.aliases[query] || query] = queryObject;
      callback.call(context, {
        matcher: queryObject.mqMatcher,
        alias: query
      }); // initial trigger

      return this;
    }
  }, {
    key: "off",
    value: function off(query, callback, context) {
      var _this = this;

      if (!arguments.length) {
        // remove all listeners
        Object.entries(this.queries).forEach(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              key = _ref2[0],
              queryObject = _ref2[1];

          _this._removeQueryObject(queryObject, key);
        });
        return this;
      }

      if (!callback) {
        // remove all listeners for a query
        this._removeQueryObject(query);

        return this;
      } // remove a particular listener for a query


      var queryObject = this.queries[this.aliases[query] || query];

      if (queryObject) {
        var handlers = queryObject.handlers;
        handlers.forEach(function (handler, i) {
          var match = handler.callback === callback;
          if (match && context) match = handler.context === context;
          if (match) handlers.splice(i, 1);
        });
        if (!handlers.length) this._removeQueryObject(query);
      }

      return this;
    }
  }, {
    key: "_removeQueryObject",
    value: function _removeQueryObject(qObject, query) {
      if (typeof qObject === 'string') {
        query = qObject;
        qObject = undefined;
      }

      query = this.aliases[query] || query;
      var queryObject = qObject || this.queries[query];

      if (queryObject) {
        queryObject.mqMatcher.removeListener(queryObject.listener);
        delete this.queries[query];
      }
    }
  }]);

  return Mq;
}();

var hyphenize = function hyphenize(str) {
  return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
};

var o2mq = function o2mq(queryObject) {
  if (typeof queryObject === 'string' || !queryObject) return queryObject;
  return Object.entries(queryObject).reduce(function (mq, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        feature = _ref2[0],
        value = _ref2[1];

    feature = hyphenize(feature);

    if (typeof value === 'boolean') {
      mq.push(value ? "".concat(feature) : "not ".concat(feature));
    } else {
      var isDimension = /[height|width]$/.test(feature) && Number.isFinite(+value);
      mq.push("(".concat(feature, ": ").concat(isDimension ? +value + 'px' : value, ")"));
    }

    return mq;
  }, []).join(' and ');
};

var toMqString = function toMqString(query) {
  return (Array.isArray(query) ? query : [query]).map(function (q) {
    return o2mq(q);
  }).join(', ');
};

var DEFAULT_ALIASES = {
  sm: 680,
  md: [681, 1024],
  lg: [1025]
};

var toMqValue = function toMqValue(v) {
  return Number.isFinite(+v) ? "".concat(+v, "px") : v;
};

var isUnitValue = function isUnitValue(v) {
  return Number.isFinite(+v) || typeof v === 'string' && ['px', 'em'].includes(v.slice(-2));
};

var isDimension = function isDimension(v) {
  return Array.isArray(v) && v.length && v.length < 3 && v.every(function (_v) {
    return _v === Infinity || isUnitValue(_v);
  }) || isUnitValue(v);
};
var extractModifiers = function extractModifiers(alias, _ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      lower = _ref2[0],
      upper = _ref2[1];

  var modifiers = {};
  if (lower !== '0px' && lower !== '0em' && upper !== Infinity && typeof upper !== 'undefined') modifiers["".concat(alias, "!")] = toMqString({
    minWidth: lower
  });
  if (upper !== Infinity && typeof upper !== 'undefined') modifiers["".concat(alias, "+")] = toMqString({
    minWidth: upper
  });
  return modifiers;
};
function aliasesToMqStrings() {
  var aliases = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_ALIASES;
  if (!aliases && typeof aliases !== 'undefined') return {};
  return Object.entries(aliases).reduce(function (association, _ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        alias = _ref4[0],
        bounds = _ref4[1];

    var isDim = isDimension(bounds);

    if (isDim) {
      if (Array.isArray(bounds) && bounds.length === 1) bounds.push(Infinity);
      var lower = Array.isArray(bounds) ? toMqValue(bounds[0]) : '0px';

      var _ubound = Array.isArray(bounds) ? bounds[1] : bounds;

      var upper = {
        '!': toMqValue(_ubound),
        '+': Number.isFinite(+_ubound) ? toMqValue(+_ubound + 1) : _ubound
      };
      var mqObject = {};
      if (lower !== '0px') mqObject.minWidth = lower;
      if (upper['!'] !== Infinity) mqObject.maxWidth = upper['!'];
      association = Object.assign(association, _defineProperty({}, alias, toMqString(mqObject)), extractModifiers(alias, [lower, upper['+']]));
    } else {
      association[alias] = toMqString(bounds);
    }

    return association;
  }, {});
}

var component = {
  name: 'MqShow',
  props: {
    if: {
      required: true,
      type: [String, Array, Object] // TODO: in docs: remember that we cannot do for example ['screen', {'min-width': 100 }] we must wrap it in another array

    },
    tag: {
      type: String,
      default: 'DIV'
    }
  },
  data: function data() {
    return {
      localMQAliases: {}
    };
  },
  computed: {
    shouldRenderChildren: function shouldRenderChildren() {
      var _this = this;

      return Array.isArray(this.if) ? this.if.some(function (alias) {
        return _this.getMatchingHolderValue(alias);
      }) : this.getMatchingHolderValue(this.if);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    if (!this.if) return;
    var ifs = Array.isArray(this.if) ? this.if : [this.if];
    ifs.forEach(function (_if) {
      _if = toMqString(_if);

      if (!(_if in _this2.$mqAliases)) {
        _this2.$mq.on(_if, _this2.enter, _this2);
      }
    });
  },
  methods: {
    enter: function enter(_ref) {
      var matcher = _ref.matcher,
          alias = _ref.alias;

      if (alias in this.localMQAliases) {
        this.localMQAliases[alias] = matcher.matches;
      } else {
        this.localMQAliases = Object.assign({}, this.localMQAliases, _defineProperty({}, alias, matcher.matches));
      }
    },
    getMatchingHolderValue: function getMatchingHolderValue(alias) {
      if (!alias) return false;
      alias = toMqString(alias);
      return !!(alias in this.localMQAliases ? this.localMQAliases : this.$mqAliases)[alias];
    }
  },
  render: function render(h) {
    return this.shouldRenderChildren ? this.$slots.default && this.$slots.default.length === 1 ? this.$slots.default[0] : h(this.tag, this.$slots.default) : h();
  },
  beforeDestroy: function beforeDestroy() {
    var _this3 = this;

    Object.keys(this.localMQAliases).forEach(function (_if) {
      return _this3.$mq.off(_if, _this3.enter, _this3);
    });
  }
};

var MqShowDirective = {
  name: 'mq-show-if',
  bind: function bind(el, _ref, _ref2) {
    var alias = _ref.value;
    var vm = _ref2.context;
    if (!alias) return;
    var ifs = Array.isArray(alias) ? alias : [alias];
    ifs.forEach(function (_if) {
      _if = toMqString(_if);

      if (!(_if in vm.$mqAliases)) {
        vm.$mq.on(_if, enter, el);
      }
    });
  },
  inserted: handleUpdate,
  updated: handleUpdate,
  componentUpdated: handleUpdate,
  unbind: function unbind(el, _ref3, _ref4) {
    var alias = _ref3.value;
    var vm = _ref4.context;
    (Array.isArray(alias) ? alias : [alias]).forEach(function (a) {
      a = toMqString(a); // eslint-disable-line

      !(a in vm.$mqAliases) && vm.off(a, enter, el);
    });
  }
};

function handleUpdate(el, _ref5, _ref6) {
  var alias = _ref5.value;
  var vm = _ref6.context;
  var matches = (Array.isArray(alias) ? alias : [alias]).some(function (a) {
    return getMatchingHolderValue.call(vm, a);
  });
  toggle(el, matches);
}

function getMatchingHolderValue(alias) {
  if (!alias) return false;
  alias = toMqString(alias);
  if (alias in this.$mqAliases) return !!this.$mqAliases[alias];
  var q = this.$mq.aliases[alias] || alias;
  return this.$mq.queries[q] ? this.$mq.queries[q].mqMatcher.matches : false;
}

function enter(_ref7) {
  var matcher = _ref7.matcher;
  toggle(this, matcher.matches);
}

function toggle(el, value) {
  if (!value) el.style.display = 'none';else el.style.display = '';
}

var install = function install(Vue) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      aliases = _ref.aliases;

  var queries = aliasesToMqStrings(aliases);
  var reactiveSource = new Vue({
    data: function data() {
      return {
        matchingQueries: {},
        lastActiveAlias: null
      };
    }
  });
  var mq = new Mq(queries);
  Object.keys(mq.aliases).forEach(function (alias) {
    var enter = function enter(_ref2) {
      var matcher = _ref2.matcher;

      if (alias in reactiveSource.matchingQueries) {
        reactiveSource.matchingQueries[alias] = matcher.matches;
      } else {
        reactiveSource.matchingQueries = Object.assign({}, reactiveSource.matchingQueries, _defineProperty({}, alias, matcher.matches));
      }

      if (matcher.matches) reactiveSource.lastActiveAlias = alias;
    };

    mq.on(alias, enter);
  });
  Vue.mixin({
    computed: {
      $mqAliases: function $mqAliases() {
        return reactiveSource.matchingQueries;
      },
      $lastActiveMQAlias: function $lastActiveMQAlias() {
        return reactiveSource.lastActiveAlias;
      }
    }
  });
  Vue.prototype.$mq = mq;
  Vue.component(component.name, component);
  Vue.directive(MqShowDirective.name, MqShowDirective);
};

var index = {
  install: install,
  Mq: Mq,
  toMqString: toMqString
};

export default index;
